import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { useTranslation } from "react-i18next";
import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../../St/Reports/UseStyle';
import { get } from "@awesome-cordova-plugins/core/decorators/common";
import { invoicePayTypes } from "../../../../../services/invoice-service";
import { sto } from "../../../../../Context/InshData";
import { Box, IconButton } from "@material-ui/core";
import { Search } from "@material-ui/icons";
export default function SearchInvForm(props) {
    const {
        AutoOptions,
        rptParamsSearch,
        onChangeData,
        onChangeAutoData,
        isPurches,
        gets,
        customers,
        BillCase,
        PcIdIvPc,
        viewHandle,
        searchCustText,
        handleInputSearchCust,
        handleIconSearchCust
    } = props;

    const { t } = useTranslation(["forms"]);

    const clasup = useStylesUp();
    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();


    const clashd = useStylesHed();
    const clasBA = useStylesBA();
    const clasTD = useStylesTD();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const handleFocus = (e) => e.target.select();

    return (
        <React.Fragment>
            <Grid container style={{ padding: 5 }} spacing={1}>
                <Grid container item lg={3} md={4} sm={6} xs={12} spacing={1} >
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="bill_no"
                            label={t("invoice-id")}
                            className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                            type="text"
                            name="bill_no" value={rptParamsSearch.bill_no} onChange={onChangeData('bill_no')}
                            InputProps={{
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        viewHandle(event);
                                    }
                                },
                                className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                            }}
                            onFocus={handleFocus}
                        />
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="refno"
                            label={t("ref-no")}
                            placeholder={t("ref-no")}

                            className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                            // InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                            type="text"
                            name="refno" value={rptParamsSearch.refno} onChange={onChangeData('refno')}
                            InputProps={{
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        viewHandle(event);
                                    }
                                },
                                className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                            }}
                        />
                    </Grid>
                </Grid>

                <Grid container item lg={3} md={4} sm={6} xs={12} spacing={1} >

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={isPurches ? calsPurch : clasAo}
                            value={rptParamsSearch.inv_type}
                            onChange={(event, newValue) => {
                                onChangeAutoData("inv_type", newValue);
                                // console.log(newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={gets.types??[]}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="typeinvs"
                                    {...params}
                                    label={t("invoice-type")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                                />
                            )}
                        />

                    </Grid>

                    <Grid item lg={6} md={6} sm={6} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={isPurches ? calsPurch : clasAo}
                            value={rptParamsSearch.pay_type}
                            onChange={(event, newValue) => {
                                onChangeAutoData("pay_type", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={invoicePayTypes}
                            disabled={rptParamsSearch?.inv_type?.id != 2}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="pay_type"
                                    {...params}
                                    label={t("pay-type")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                                />
                            )}
                        />

                    </Grid>
                </Grid>


                {rptParamsSearch.inv_type.id == 1 && PcIdIvPc === "02" && (
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={isPurches ? calsPurch : clasAo}
                            value={rptParamsSearch.BillCase}
                            onChange={(event, newValue) => {
                                onChangeAutoData("BillCase", newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={BillCase}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="typeinvs"
                                    {...params}
                                    label={t("invoice_kind")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                                />
                            )}
                        />

                    </Grid>
                )}


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={isPurches ? calsPurch : clasAo}
                        value={rptParamsSearch.bank}
                        onChange={(event, newValue) => {
                            onChangeAutoData("bank", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions.Banks}
                        disabled={rptParamsSearch?.pay_type?.id != 2}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                id="bank"
                                {...params}
                                label={t("bank")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={isPurches ? calsPurch : clasAo}
                        value={rptParamsSearch.user}
                        onChange={(event, newValue) => {
                            onChangeAutoData("user", newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={AutoOptions.Users}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                id="sales_emp"
                                {...params}
                                label={t("user")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                            />
                        )}
                    />

                </Grid>
                {sto.User_typei == 1 && (
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <Autocomplete
                            classes={isPurches ? calsPurch : clasAo}
                            value={rptParamsSearch.sales_man}
                            onChange={(event, newValue) => {
                                onChangeAutoData("sales_man", newValue);
                                // console.log(newValue);
                            }}
                            id="controllable-states-demo"
                            size="small"
                            options={gets.salesmen}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    id="sales_man"
                                    {...params}
                                    label={t("delegate")}
                                    variant="outlined"
                                    size="small"
                                    InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                                />
                            )}
                        />

                    </Grid>
                )}
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete
                        classes={isPurches ? calsPurch : clasAo}
                        value={rptParamsSearch.center}
                        onChange={(event, newValue) => {
                            onChangeAutoData("center", newValue);
                            // console.log(newValue);
                        }}
                        id="controllable-states-demo"
                        size="small"
                        options={[{ id: -1, name: "الكل" }, ...gets.costcenters] }
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                id="center"
                                {...params}
                                label={t("center")}
                                variant="outlined"
                                size="small"
                                InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                            />
                        )}
                    />

                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <Autocomplete classes={isPurches ? calsPurch : clasAo}
                        value={rptParamsSearch.branch}
                        onChange={(event, newValue) => {
                            //   setBranch(newValue);
                            onChangeAutoData("branch", newValue);

                        }}
                        id="combo-box-demo"
                        size="small"
                        options={AutoOptions.Branches}
                        disabled={true}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }

                        style={{}}
                        disableClearable
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={t("branch")}
                                variant="outlined"
                                InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                            />
                        )}

                    />
                </Grid>

                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>

                    <Autocomplete classes={isPurches ? calsPurch : clasAo}
                        value={rptParamsSearch.cust}
                        onInputChange={(event, newValue, reason) => {
                            if (reason === "input") handleInputSearchCust(event, newValue, reason);
                        }}
                        size="small"
                        options={customers}
                        getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.name
                        }
                        disableClearable
                        renderInput={(params) => (
                            <Box size="small" display={"flex"} textAlign={"center"}>
                                <TextField
                                    {...params}
                                    label={isPurches ? t("supplier") : t("customer")}
                                    variant="outlined"
                                    fullWidth
                                    size="small"
                                    textAlign={"center"}
                                    id="searchCust"
                                    InputLabelProps={{ className: isPurches ? claslbl.clrBlack : claslbl.clrSale }}
                                />
                                {searchCustText != "" &&
                                    (
                                        <IconButton size="small" onClick={handleIconSearchCust}>
                                            <Search />
                                        </IconButton>
                                    )}
                            </Box>
                        )}
                        onChange={(event, newValue) => {
                            onChangeAutoData("cust", newValue);
                        }}
                    />
                </Grid>


                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small"
                        id="cust_mobile`"
                        label={t("customer_phone")}
                        className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                        // InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                        type="text"
                        name="cust_mobile" value={rptParamsSearch.cust_mobile} onChange={onChangeData('cust_mobile')}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    viewHandle(event);
                                }
                            },
                            className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                        }}
                    />
                </Grid>
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateFrom"
                        label={t("date-from")}
                        className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                        // InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                        type="date" format="YYYY-MM-DD"
                        name="dateFrom" value={rptParamsSearch.dateFrom}
                        onChange={onChangeData('dateFrom')}
                        InputProps={{
                            onKeyDown: (event) => {
                                if (event.key === 'Enter') {
                                    viewHandle(event);
                                }
                            },
                            className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                        }}
                    /></Grid>
                {rptParamsSearch.selectTime.id == 2 && (
                    <Grid item lg={2} md={2} sm={3} xs={6}>
                        <TextField fullWidth variant="outlined" size="small" id="timeFrom"
                            label={t("time")}
                            className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                            //  InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                            type="time"
                            format="HH:mm"
                            name="timeFrom" value={rptParamsSearch.timeFrom}
                            onChange={onChangeData('timeFrom')}
                            InputProps={{
                                onKeyDown: (event) => {
                                    if (event.key === 'Enter') {
                                        viewHandle(event);
                                    }
                                },
                                className: isPurches ? claslbl.clrPurch : claslbl.clrSale
                            }}
                        /></Grid>
                )}
                <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                    <TextField fullWidth variant="outlined" size="small" id="dateTo"
                        label={t("date-to")}
                        className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                        InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                        type="date" format="YYYY-MM-DD"
                        name="dateTo" value={rptParamsSearch.dateTo} onChange={onChangeData('dateTo')}
                    /></Grid>

                {rptParamsSearch.selectTime.id == 2 && (
                    <Grid item lg={2} md={2} sm={3} xs={6} style={{ paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small" id="timeTo"
                            label={t("time")}
                            className={isPurches ? clasTF.rootPurch : clasTF.rootSale}
                            InputProps={{ className: isPurches ? claslbl.clrPurch : claslbl.clrSale }}
                            type="time"
                            format="HH:mm"
                            name="timeTo" value={rptParamsSearch.timeTo} onChange={onChangeData('timeTo')}
                        /></Grid>
                )}

            </Grid>
        </React.Fragment>
    );
}
